module.exports = __webpack_public_path__ + "media/images/lb/436-673feeda999cc9fa8c54e6eec6109062.svg";